"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4h2.25a2 2 0 0 1 1.92 1.44l2.7884 9.5602C20.8814 14.989 22.5 16.5678 22.5 18.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5c0-1.2104.6144-2.2772 1.5483-2.9058l-.4814-1.6507L11.4378 19.5H8.3551C7.9248 20.9457 6.5855 22 5 22c-1.933 0-3.5-1.567-3.5-3.5 0-2.0416 1.8195-3.6799 3.8424-3.4835l2.7032-3.7169L7.3886 9H6V7h5v2H9.4686l.2857 1h5.6624L14.25 6H12V4zM7.2387 15.8095A3.5032 3.5032 0 0 1 8.355 17.5h1.462l-1.074-3.7591-1.5044 2.0686zM10.3257 12l1.2559 4.3956L15.6391 12h-5.3134zM19 20c-.8284 0-1.5-.6716-1.5-1.5S18.1716 17 19 17s1.5.6716 1.5 1.5S19.8284 20 19 20zM3.5 18.5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5S5.8284 17 5 17s-1.5.6716-1.5 1.5z"
  })];
};

exports.default = _default;